import { render, staticRenderFns } from "./add-coupon.vue?vue&type=template&id=08d3a9b8&"
import script from "./add-coupon.vue?vue&type=script&lang=js&"
export * from "./add-coupon.vue?vue&type=script&lang=js&"
import style0 from "./add-coupon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d3a9b8')) {
      api.createRecord('08d3a9b8', component.options)
    } else {
      api.reload('08d3a9b8', component.options)
    }
    module.hot.accept("./add-coupon.vue?vue&type=template&id=08d3a9b8&", function () {
      api.rerender('08d3a9b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/account/coupon/add-coupon.vue"
export default component.exports